import React from 'react';
import PanelSection from '../../FormElements/PanelSection';

export default class UserLearningPlanExamsData extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			user_learning_plans: props.user_learning_plans || []
		};

		this.onChangeLock = this.onChangeLock.bind(this);
		this.onChangeScoreReleased = this.onChangeScoreReleased.bind(this);
	}

	render() {
		// console.log('UserLearningPlanExamsData - this.props', this.props);
		const { title } = this.props;
		const { user_learning_plans = [] } = this.state;

		return (
			<div className="UserPersonalInfo" style={{ position: 'relative' }}>
				<PanelSection title={title} hideEditLink={true}>
					<table className="table">
						<thead>
							<tr>
								<th scope="col" style={{ textTransform: 'capitalize' }}>
									{I18n.t('exam')}
								</th>
								<th scope="col" style={{ textTransform: 'capitalize' }}>
									{I18n.t('completed')}
								</th>
								<th scope="col" style={{ textTransform: 'capitalize' }}>
									{I18n.t('locked')}
								</th>
								{this.props.permissionsHelper.isOnlyProctor() ? null : (
									<th scope="col" style={{ textTransform: 'capitalize' }}>
										{I18n.t('score_released')}
									</th>
								)}
							</tr>
						</thead>
						{this.renderExams(user_learning_plans)}
					</table>
					{this.state.loading ? (
						<div className="loadingOverlay" style={{ bottom: '0' }}>
							<div className="spinner" />
						</div>
					) : null}
				</PanelSection>
			</div>
		);
	}

	renderExams(user_learning_plans) {
		return user_learning_plans.map((user_learning_plan, index) => {
			return user_learning_plan.learning_plan.learning_plan_sections.map(
				(learning_plan_section, index) => {
					return learning_plan_section.learning_plan_items.map(
						(learning_plan_item, index) => {
							if (learning_plan_item.learnable_type === 'Exam') {
								// console.log("learning_plan_item", learning_plan_item);
								const {
									learnable: exam,
									user_assessments = []
								} = learning_plan_item;
								if (
									(exam.locked || exam.score_released === 'manual') &&
									user_assessments &&
									user_assessments.length > 0
								) {
									return (
										<tbody key={exam.id}>
											{user_assessments.map((user_assessment) => {
												// console.log("user_assessment", user_assessment);
												const completed_at = new Date(
													user_assessment.completed_at
												);
												return (
													<tr key={user_assessment.id}>
														<td>{exam.name}</td>
														{user_assessment.completed_at ? (
															<td>
																{completed_at.toLocaleDateString('en-us', {
																	weekday: 'long',
																	year: 'numeric',
																	month: 'short',
																	day: 'numeric'
																})}{' '}
																{completed_at.toLocaleTimeString('en-us', {
																	hour: 'numeric',
																	minute: 'numeric'
																})}
															</td>
														) : (
															<td>{I18n.t('na')}</td>
														)}
														<td>
															{user_assessment.completed_at ? (
																<select
																	className="form-control form-control-sm"
																	style={{ width: 'auto' }}
																	defaultValue={true}
																>
																	<option value="true">{I18n.t('yes')}</option>
																</select>
															) : (
																<select
																	className="form-control form-control-sm"
																	style={{ width: 'auto' }}
																	name={user_assessment.id + '_locked'}
																	value={user_assessment.locked !== false}
																	onChange={(e) => {
																		this.onChangeLock(e, user_assessment);
																	}}
																>
																	<option value="true">{I18n.t('yes')}</option>
																	<option value="false">{I18n.t('no')}</option>
																</select>
															)}
														</td>
														<td>
															{!this.props.permissionsHelper.isOnlyProctor() ? (
																<select
																	className="form-control form-control-sm"
																	style={{ width: 'auto' }}
																	name={user_assessment.id + '_score_released'}
																	value={
																		user_assessment.score_released === true
																	}
																	onChange={(e) => {
																		this.onChangeScoreReleased(
																			e,
																			user_assessment
																		);
																	}}
																>
																	<option value="true">{I18n.t('yes')}</option>
																	<option value="false">{I18n.t('no')}</option>
																</select>
															) : null}
														</td>
													</tr>
												);
											})}
										</tbody>
									);
								}
							}
						}
					);
				}
			);
		});
	}

	onChangeLock(e, user_assessment) {
		this.setState({ loading: true });
		$.ajax({
			type: 'POST',
			url: this.props.lock_unlock_assessment_endpoint + '/' + user_assessment.id
		}).done((data) => {
			this.setState({ loading: false, user_learning_plans: data });
		});
	}

	onChangeScoreReleased(e, user_assessment) {
		this.setState({ loading: true });
		$.ajax({
			type: 'POST',
			url:
				this.props.score_released_assessment_endpoint + '/' + user_assessment.id
		}).done((data) => {
			this.setState({ loading: false, user_learning_plans: data });
		});
	}
}
